var bxpFormReferrerParamsDefault = {
  httpReferrer: 0,
  ctaReferrer: 0,
  hsMeetingFormUrl: 'https://meetings.hubspot.com/benvw/bountixp-product-demo?embed=true'
};
export const LocalisedVarsMixin = {
  data() {
    return {
      referrerParams: process.env.NODE_ENV === "production" ? bxpFormReferrerParams : bxpFormReferrerParamsDefault
    };
  }
};
